import PropTypes from 'prop-types';

export const InvoicesAccessDefaultProps = {
  invoices: [],
  number: null,
};

export const InvoicesAccessPropTypes = {
  invoices: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      date: PropTypes.string,
      total_raw: PropTypes.number,
    }),
  ),
  number: PropTypes.number,
};
